import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Loading from './components/Loading';
import { ProtectedRoute, WithLayoutRoute } from './routers';

import { AdminLayout, PublicLayout } from './layouts';

// Admin
const DashboardPage = lazy(() => import('./pages/Admin/Dashboard'));
const MovieList = lazy(() => import('./pages/Admin/MovieList'));
const EventList = lazy(() => import('./pages/Admin/EventList'));
const CinemaList = lazy(() => import('./pages/Admin/CinemaList'));
const ShowtimeList = lazy(() => import('./pages/Admin/ShowtimeList'));
const ReservationList = lazy(() => import('./pages/Admin/ReservationList'));
const User = lazy(() => import('./pages/Admin/User'));
const Account = lazy(() => import('./pages/Admin/Account'));
const ListAllShow = lazy(()=> import('./pages/Admin/ListAllShow'))
const OtherTheatre = lazy(() => import('./pages/Admin/otherTheatres'));
const EventBooking = lazy(() => import('./pages/Admin/eventBooking'));



// Register - Login
const Register = lazy(() => import('./pages/Public/Register'));
const Login = lazy(() => import('./pages/Public/Login'));

// Public
const HomePage = lazy(() => import('./pages/Public/HomePage'));
const MoviePage = lazy(() => import('./pages/Public/MoviePage'));
const MyDashboard = lazy(() => import('./pages/Public/MyDashboard'));
const MovieCategoryPage = lazy(() => import('./pages/Public/MovieCategoryPage'));
const CinemasPage = lazy(() => import('./pages/Public/CinemasPage'));
const BookingPage = lazy(() => import('./pages/Public/BookingPage'));
const SeatBooking = lazy(() => import('./pages/Public/BookingPage/seatBooking'));
const Payment = lazy(() => import('./pages/Public/BookingPage/PaymentPage'));
const Checkin = lazy(() => import('./pages/Public/Checkin'));
const ContactUs = lazy(() => import('./pages/Public/ContactUs'));
const ERecipt = lazy(() => import('./pages/Public/eRecipt/ERecipt'));
const ShowCity = lazy(() => import('./pages/Public/showPlace/showCity'));
const EventPage = lazy(() => import('./pages/Public/event/event'));
const BookEventPage = lazy(() => import('./pages/Public/event/bookEvent'));
const EventERecipt = lazy(() => import('./pages/Public/eReciptEvent/EventERecipt'));
const TermsAndConditions = lazy(() => import('./pages/Public/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('./pages/Public/PrivacyPolicy'));
const ReturnRefundPolicy = lazy(() => import('./pages/Public/ReturnRefundPolicy'));


const Routes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />

          <WithLayoutRoute
            exact
            path="/checkin/:reservationId"
            component={Checkin}
            layout={PublicLayout}
          />

          <WithLayoutRoute
            exact
            path="/"
            layout={PublicLayout}
            component={HomePage}
          />
          <WithLayoutRoute
            exact
            path="/mydashboard"
            layout={PublicLayout}
            component={MyDashboard}
          />
          <WithLayoutRoute
            exact
            path="/cinemas"
            layout={PublicLayout}
            component={CinemasPage}
          />
          <WithLayoutRoute
            exact
            path="/events"
            layout={PublicLayout}
            component={EventPage}
          />
          <WithLayoutRoute
            exact
            path="/event/:id"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={BookEventPage}
          />
          <WithLayoutRoute
            exact
            path="/movie/category/:category"
            layout={PublicLayout}
            component={MovieCategoryPage}
          />
          <WithLayoutRoute
            exact
            path="/movie/:id"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={MoviePage}
          />
          <WithLayoutRoute
            exact
            path="/movie/booking/:slug/:id/:city"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={BookingPage}
          />
          <WithLayoutRoute
            exact
            path="/movie/places/show-cities/:slug/:id"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={ShowCity}
          />
          <WithLayoutRoute
            exact
            path="/seatBooking/:showDateAndTime/:showid/:movieSlug/:seatcount"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={SeatBooking}
          />
          <WithLayoutRoute
            exact
            path="/payment"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={Payment}
          />
          <WithLayoutRoute
            exact
            path="/erecipt/:id"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={ERecipt}
          />
          <ProtectedRoute
            exact
            path="/admin/dashboard"
            layout={AdminLayout}
            component={DashboardPage}
          />
          <ProtectedRoute
            exact
            path="/admin/users"
            layout={AdminLayout}
            component={User}
          />
          <WithLayoutRoute
            exact
            path="/event-erecipt/:id"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={EventERecipt}
          />
          <ProtectedRoute
            exact
            path="/admin/events"
            layout={AdminLayout}
            component={EventList}
          />
          <ProtectedRoute
            exact
            path="/admin/events-bookings"
            layout={AdminLayout}
            component={EventBooking}
          />
          <ProtectedRoute
            exact
            path="/admin/showtimes"
            layout={AdminLayout}
            component={ShowtimeList}
          />
          <ProtectedRoute
            exact
            path="/admin/listallshow"
            layout={AdminLayout}
            component={ListAllShow}
          />
          <ProtectedRoute
            exact
            path="/admin/bookings"
            layout={AdminLayout}
            component={ReservationList}
          />
          <ProtectedRoute
            exact
            path="/admin/cinemas"
            layout={AdminLayout}
            component={CinemaList}
          />
          <ProtectedRoute
            exact
            path="/admin/movies"
            layout={AdminLayout}
            component={MovieList}
          />
          <ProtectedRoute
            exact
            path="/admin/account"
            layout={AdminLayout}
            component={Account}
          />
          <ProtectedRoute
            exact
            path="/admin/otherTheatres"
            layout={AdminLayout}
            component={OtherTheatre}
          />
          <WithLayoutRoute
            exact
            path="/ContactUs"
            layout={PublicLayout}
            layoutProps={{ withFooter: false }}
            component={ContactUs}
          />
          <WithLayoutRoute
            exact
            path="/terms-and-conditions"
            layout={PublicLayout}
            component={TermsAndConditions}
          />
          <WithLayoutRoute
            exact
            path="/privacy-policy"
            layout={PublicLayout}
            component={PrivacyPolicy}
          />
          <WithLayoutRoute
            exact
            path="/return-refund-policy"
            layout={PublicLayout}
            component={ReturnRefundPolicy}
          />
          <Route path="*" component={() => '404 NOT FOUND'} />
        </Switch>
      </Router>
    </Suspense>
  );
};

export default Routes;
